import { Logged } from "@/routing";
import { observer } from "mobx-react-lite";
import { FunctionComponent, ReactElement } from "react";

export const Index: FunctionComponent = observer((): ReactElement => {
  return (
    <Logged>
      <>В разработке</>;
    </Logged>
  );
});
